/**
 * Help Trigger Component
 *
 * Purpose: Reusable ? icon button that triggers help display
 * Created: March 24, 2026
 */

import React from 'react';
import { HelpCircle } from 'lucide-react';
import { cn } from '@xanectech/ui/lib';
import { useHelpSafe } from '../contexts/HelpContext';

interface HelpTriggerProps {
  onClick?: () => void;
  className?: string;
  size?: number;
  'aria-label'?: string;
}

export const HelpTrigger: React.FC<HelpTriggerProps> = ({
  onClick,
  className,
  size = 14,
  'aria-label': ariaLabel = 'Help',
}) => {
  const helpContext = useHelpSafe();
  return (
    <button
      type='button'
      aria-label={ariaLabel}
      onClick={onClick}
      className={cn(
        'inline-flex items-center justify-center rounded-full',
        'text-muted-foreground hover:text-primary',
        'focus:outline-none focus:ring-1 focus:ring-ring',
        'transition-colors',
        className,
      )}
    >
      <HelpCircle size={size} />
    </button>
  );
};
